import { API_URL } from '../config/api';

/**
 * Get the backend base URL without the /api/v1 prefix for static files
 */
const getBackendBaseUrl = (): string => {
  // API_URL includes /api/v1, but static files are served from backend root
  // Extract just the base URL (protocol + domain + port)
  const url = new URL(API_URL);
  return `${url.protocol}//${url.host}`;
};

/**
 * Constructs the full URL for an uploaded image
 * @param imagePath - The relative path from the database (e.g., "/uploads/invoices/filename.png")
 * @returns Full URL to access the image
 */
export const getImageUrl = (imagePath: string | undefined): string | undefined => {
  if (!imagePath) return undefined;
  
  // If the path already includes the protocol, return as-is (production URLs)
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // For local development and relative paths, use backend base URL (without /api/v1)
  // Remove leading slash if present to avoid double slashes
  const cleanPath = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
  
  return `${getBackendBaseUrl()}/${cleanPath}`;
};

/**
 * Gets the download URL for an image (same as getImageUrl but more semantic)
 */
export const getImageDownloadUrl = (imagePath: string | undefined): string | undefined => {
  return getImageUrl(imagePath);
};
